import { createContext } from "react"

interface IAppState {
  scrollPosition: number
  setScrollPosition: (position: number) => void
}

export const AppContext = createContext<IAppState | null>(null)
